// SWIPER
var swipers = [];

var set_swiper_pagination = function(swiper_state) {
	if( swiper_state.pagination ) {
		setTimeout(function(){
			var remove = false;
			$(swiper_state.pagination['$el']).find('.swiper-pagination-bullet').each(function(){
				if( remove == false ) {
					$(this).addClass('swiper-pagination-pseudo-active');
				} else {
					$(this).removeClass('swiper-pagination-pseudo-active');
				}
				if( $(this).is('.swiper-pagination-bullet-active') ) {
					remove = true;
				}
			});
		}, 50);
	}
}

var show_hide_swiper_nav = function() {
	$.each(swipers, function(key, swiper){
		var $swiper_parent = $('#swiper-pagination-' + key).closest('.swiper-button-container');
		if( $('#swiper-pagination-' + key).find('.swiper-pagination-bullet').length > 1 ) {
			$swiper_parent.show();
		} else {
			$swiper_parent.hide();
		}
	})
}

var set_swipers = function() {
	$('.swiper-container').each(function(){
		if( ! $(this).is('.init') ) {
			$(this).addClass('init');

			var swiper_key = swipers.length;

			// SET IDS
			$(this).attr('data-swiper-id', swiper_key );
			if( ! $(this).attr('id') ) {
				$(this).attr('id', 'swiper-' + swiper_key);
			}
			$(this).find('.swiper-pagination').attr('id', 'swiper-pagination-' + swiper_key);
			$(this).find('.swiper-button-prev').attr('id', 'swiper-prev-' + swiper_key);
			$(this).find('.swiper-button-next').attr('id', 'swiper-next-' + swiper_key);
			
			if( $(this).is('.swiper-default') ) {
				swipers[swiper_key] = new Swiper( '#' + $(this).attr('id'), {
					pagination: {
						el			: '#swiper-pagination-' + swiper_key,
						type		: 'bullets',
						clickable	: true
					},
					navigation		: {
						nextEl			: '#swiper-next-' + swiper_key,
						prevEl			: '#swiper-prev-' + swiper_key,
					},
					on: {
						init: function(swiper_state) {
							$(window).trigger('scroll');
							set_swiper_pagination(swiper_state);
						},
						snapIndexChange: function(swiper_state) {
							set_swiper_pagination(swiper_state);
			 			}
					}
				});
			} else if( $(this).is('.swiper-products') ) {
				swipers[swiper_key] = new Swiper( '#' + $(this).attr('id'), {
					slidesPerView: 'auto',
					spaceBetween: 20,
					pagination: {
						el			: '#swiper-pagination-' + swiper_key,
						type		: 'bullets',
						clickable	: true
					},
					navigation: {
						nextEl: '#swiper-next-' + swiper_key,
						prevEl: '#swiper-prev-' + swiper_key,
					},
					on: {
						init: function(swiper_state) {
							$(window).trigger('scroll');
							set_swiper_pagination(swiper_state);
						},
						snapIndexChange: function(swiper_state) {
							set_swiper_pagination(swiper_state);
						}
					}
				});
			} else if( $(this).is('.swiper-resources') ) {
				swipers[swiper_key] = new Swiper( '#' + $(this).attr('id'), {
					slidesPerView: 'auto',
					spaceBetween: 20,
					pagination: {
						el			: '#swiper-pagination-' + swiper_key,
						type		: 'bullets',
						clickable	: true
					},
					navigation: {
						nextEl: '#swiper-next-' + swiper_key,
						prevEl: '#swiper-prev-' + swiper_key,
					},
					on: {
						init: function(swiper_state) {
							$(window).trigger('scroll');
							set_swiper_pagination(swiper_state);
						},
						snapIndexChange: function(swiper_state) {
							set_swiper_pagination(swiper_state);
						}
					}
				});
			} else if( $(this).is('.swiper-text-image-columns') ) {
				swipers[swiper_key] = new Swiper( '#' + $(this).attr('id'), {
					// slidesPerView: 1,
					// spaceBetween: 20,
					pagination: {
						el			: '#swiper-pagination-' + swiper_key,
						type		: 'bullets',
						clickable	: true
					},
					navigation: {
						nextEl: '#swiper-next-' + swiper_key,
						prevEl: '#swiper-prev-' + swiper_key,
					},
					on: {
						init: function(swiper_state) {
							$(window).trigger('scroll');
							set_swiper_pagination(swiper_state);
						},
						snapIndexChange: function(swiper_state) {
							set_swiper_pagination(swiper_state);
						}
					}
				});
			} else if( $(this).is('.swiper-two-image-slider') ) {
				swipers[swiper_key] = new Swiper( '#' + $(this).attr('id'), {
					slidesPerView: 1,
					spaceBetween: 0,
					breakpoints: {
						768: {
						  slidesPerView: 2,
						  spaceBetween: 30
						},
					},
					pagination: {
						el			: '#swiper-pagination-' + swiper_key,
						type		: 'bullets',
						clickable	: true
					},
					navigation: {
						nextEl: '#swiper-next-' + swiper_key,
						prevEl: '#swiper-prev-' + swiper_key,
					},
					on: {
						init: function(swiper_state) {
							$(window).trigger('scroll');
							set_swiper_pagination(swiper_state);
						},
						snapIndexChange: function(swiper_state) {
							set_swiper_pagination(swiper_state);
						}
					}
				});	
				
			} else if( $(this).is('.footer-map-slider') ) {
				swipers[swiper_key] = new Swiper( '#' + $(this).attr('id'), {
					slidesPerView: 'auto',
					spaceBetween: 140,
					allowTouchMove: false,
					navigation: {
						nextEl: '#swiper-next-' + swiper_key,
						prevEl: '#swiper-prev-' + swiper_key,
					},
					on: {
						init: function(swiper_state) {
							
						},
						slideChangeTransitionStart: function(swiper_state) {
							var active_continent = $('.swiper-slide-continent[data-slide-key="' + swiper_state.activeIndex + '"]').attr('data-slide-continent').toLowerCase().split(' ').join('_');
							$('[data-continent-name]').removeClass('active').filter('[data-continent-name="' + active_continent + '"]').addClass('active');
						}
					}
				});
			} else if( $(this).is('.swiper-product-mobile') ) {
                
                swipers[swiper_key] = new Swiper( '#' + $(this).attr('id'), {
                    slidesPerView: 1,
                    effect: 'fade',
                    navigation: {
						nextEl: '.product-module--gallery--mobile .swiper-button-next',
						prevEl: '.product-module--gallery--mobile .swiper-button-prev',
					},
                })

            } else if( $(this).is('.swiper-product-mobile--thumbs')) {
                swipers[swiper_key] = new Swiper( '#' + $(this).attr('id'), {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                    navigation: {
						nextEl: '#swiper-next-' + swiper_key,
						prevEl: '#swiper-prev-' + swiper_key,
					},
					pagination: {
						el			: '#swiper-pagination-' + swiper_key,
						type		: 'bullets',
						clickable	: true
					},
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
					on: {
						init: function(swiper_state) {
							$(window).trigger('scroll');
							set_swiper_pagination(swiper_state);
						},
						snapIndexChange: function(swiper_state) {
							set_swiper_pagination(swiper_state);
			 			}
					}
                })
                // if we are here, there should be a .swiper-product-mobile before this swiper
                swipers[swiper_key - 1].thumbs.swiper = swipers[swiper_key];
            }
		}
	});
	show_hide_swiper_nav();
	$(window).on('resize', function(){
		show_hide_swiper_nav();
	})
}

set_swipers();